import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { FieldOrderDesc } from "@/modules/api/field-order-options";

import Attachment from "./attachment.model";

export default class AttachmentRepository extends BasicRepository<Attachment> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<Attachment>,
    responseParser: ApiCollectionResponseParserService<Attachment>
  ) {
    super("attachments", api, objectBuilder, responseParser);
  }

  public async getByMessageIds(messageIds: string[]): Promise<Attachment[]> {
    return this.fetchChunkedByFilter({ message: messageIds }, "message", [
      ["createdAt", FieldOrderDesc],
    ]);
  }
}
